export default "__VITE_ASSET__B6Y8MYmo__"